/* eslint-disable @typescript-eslint/ban-ts-comment */
import { createPinia } from 'pinia';
import { createApp } from 'vue';
// @ts-ignore
import keycloak from '~packages/plugins/keycloak';

import '@/api/base';
import { BaseApiService } from '@/api/client';
import '@/app/styles';
import router from '@/app/routers';

// import tokenHardcoded from '@/shared/constants/tokens/ivanov_omsu.json';
// import tokenHardcoded from '@/shared/constants/tokens/petrov_rou.json';
// import tokenHardcoded from '@/shared/constants/tokens/sidorov_mou.json';
// import tokenHardcoded from '@/shared/constants/tokens/vasechkin_msh.json';

/*  */
// import useKeycloakAdapterEsia from '@/utils/useKeycloakAdapterEsia';
import App from '@/app/ui/App.vue';
// @ts-ignore
import getConstants from '@/shared/constants';

/*  */
import tokenHardcoded from '@/shared/constants/tokens/admin.json';
import { defaultPath } from '@/shared/constants';
import { VueQueryPlugin } from '@tanstack/vue-query';

import { setupProvides } from './provides';

window.global ||= window;

const pinia = createPinia();

const constants = getConstants();
const {
  getVars: getEnvVars,
  isAuthEnabled,
  isModeDevelopment,
  logoutSessionStorageKey,
} = constants;
const envVars = getEnvVars();

/*  */
const app = createApp(App);
app.use(router).use(pinia);
app.use(VueQueryPlugin);

const renderApp = () => {
  setupProvides(app);
  app.mount('#app');

  if (sessionStorage.getItem(logoutSessionStorageKey)) {
    router.push(defaultPath);
    sessionStorage.setItem(logoutSessionStorageKey, '');
  }
};

const filterFix = () => {
  // {"oktmo__ilike": "212"}
  try {
    const key = 'Закладка похозяйственной книги__filter';
    const keyFlag = `${key}::cleared`;

    if (localStorage.getItem(keyFlag)) return;

    const str = localStorage.getItem(key) ?? '{}';
    const val = JSON.parse(str);

    if (!val.oktmo__like) {
      localStorage.setItem(keyFlag, 'true');
      return;
    }

    delete val.oktmo__like;
    localStorage.setItem(key, JSON.stringify(val));
    localStorage.setItem(keyFlag, 'true');
  } catch {
    //
  }
};

filterFix();

const keycloakDaoFactory = (keycloak: any, updateToken: any) => ({
  keycloak,
  updateToken: async (...args: any[]) => {
    const { tokenParsed } = await updateToken(...args);
    app.provide('token', tokenParsed);
  },
});

if (isModeDevelopment && !isAuthEnabled) {
  const requestInterceptor = ({ options }) => {
    const token = envVars.VITE_ACCESS_TOKEN;
    // console.log('token', token);
    options.headers.Authorization = `Bearer ${token}`;
    return options;
  };

  /*  */
  app.provide('token', tokenHardcoded);
  app.provide('keycloak', {
    logout: () => {
      //
    },
  });

  BaseApiService.register(requestInterceptor);
  renderApp();
} else {
  app.use(
    keycloak,
    {
      checkLoginIframe: false,
      clientId: envVars.VITE_APP_KC_CLIENT_ID,
      onLoad: 'login-required', // Перенаправлять неавторизованных пользователей на страницу входа,
      // onLoad: 'check-sso',
      realm: envVars.VITE_APP_KC_REALM,
      url: envVars.VITE_APP_KC_URL,
    },
    async ({ keycloak, updateToken }) => {
      app.provide('keycloak', keycloak);
      app.provide('keycloak-dao', keycloakDaoFactory(keycloak, updateToken));

      /*  */
      const requestInterceptor = async ({ options }) => {
        const { token } = await updateToken();
        if (token) options.headers.Authorization = `Bearer ${token}`;
        return options;
      };
      BaseApiService.register(requestInterceptor);
      const { tokenParsed } = await updateToken();
      app.provide('token', tokenParsed);

      // console.log(token);
      // console.log(tokenParsed);
      // console.log(JSON.stringify(tokenParsed, null, 2));

      /*  */
      // await useKeycloakAdapterEsia({
      //   adapterCfg: {
      //     host: envVars.VITE_APP_KC_URL,
      //     keycloak,
      //     realm: envVars.VITE_APP_KC_REALM
      //   }
      // });

      /*  */
      renderApp();
    },
    {
      addToApp: true,
      addToPrototype: false,
      app,
      onError: error => {
        console.log('Keycloak error:', error?.message || error);
      },
    }
  );
}
